import React, { useEffect, useState, useMemo } from 'react'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Paper from '@mui/material/Paper'
import Draggable from 'react-draggable'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import styled from 'styled-components'
import { Grid } from '@mui/material'
import TextField from '../../Components/common/TextField'
import MenuItem from '../../Components/common/MenuItem'
import Button from '../../Components/common/Button'

const draggableId = new Date().getTime()

const PaperComponent = (props) => (
  <Draggable bounds='parent' handle={'.dragHandle' + draggableId}>
    <Paper {...props} />
  </Draggable>
)

const PaperDefault = (props) => <Paper {...props} />

const VehicleFilerModal = ({
  openModal = true,
  onClose,
  getVehiclesList,
  title,
  selectedUser,
  draggable = false,
  hideDragIcon = false,
  background,
  viewUserDetailWidth,
  maxWidth = 'sm',
  fullWidth = true,
  translate,
  themecolors,
  alltags,
  logInUser,
  invisible,
  showSubmitbtn,
  headerActions,
  handleSubmitTagsFilter
}) => {
  const [open, setOpen] = useState(openModal)
  const [tagsState, setTagsState] = useState({
    tag_1: '',
    tag_2: '',
    tag_3: '',
    tag_4: '',
    tag_5: '',
  })

  useEffect(() => {
    setOpen(openModal)
  }, [openModal])

  const handleClose = () => {
    setOpen(false)
    onClose && onClose()
  }

  const handleChange = (name, value) => {
    setTagsState(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = () => {
    setOpen(false)
    const selectedTags = { ...tagsState }
    handleSubmitTagsFilter(selectedTags)
  }

  const { tag_1, tag_2, tag_3, tag_4, tag_5 } = alltags || {}
  const { vt1, vt2, vt3, vt4, vt5 } = logInUser?.attributes || {}

  const ThemeIconButton = styled(IconButton)`
    position: absolute !important;
    top: 0;
    right: 0;
    z-index: 9;
    border-radius: 0 !important;
    background-color: ${themecolors?.backgroundColor}!important;
    color: ${themecolors?.color}!important;
    &:hover {
      background-color: ${themecolors?.backgroundColor};
    }
  `

  const DialogActionsStyled = styled(DialogActions)`
    background-color: ${themecolors?.color};
  `

  const DragIcon = styled.span`
    position: absolute;
    width: 44px;
    height: 44px;
    text-align: center;
    font-size: 32px;
    cursor: move;
    z-index: 9;
    left: 0;
    top: 0;
    color: ${themecolors?.textcolor};
  `

  const BackdropProps = useMemo(() => {
    return invisible
      ? { invisible: true }
      : { style: { backgroundColor: 'rgba(255,255,255,0.7)' } }
  }, [invisible])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableBackdropClick
      PaperComponent={draggable ? PaperComponent : PaperDefault}
      BackdropProps={BackdropProps}
      PaperProps={{ style: { overflow: 'visible', width: viewUserDetailWidth } }}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      <ThemeIconButton aria-label='close' onClick={handleClose}>
        <CloseIcon fontSize='small' />
      </ThemeIconButton>
      {title && (
        <DialogTitle
          disableTypography
          style={{
            backgroundColor: themecolors?.textcolor,
            fontSize: 18,
            fontWeight: 500,
            minHeight: 44,
            display: 'flex',
            alignItems: 'center',
            padding: '0 0 0 44px',
            color: themecolors?.textcolor,
          }}
        >
          {title} {selectedUser || ''}
        </DialogTitle>
      )}
      <DialogContent
        style={{
          padding: '5px 10px',
          overflow: 'visible',
          background,
          height: viewUserDetailWidth || '',
        }}
      >
        {!hideDragIcon && (
          <DragIcon className={'dragHandle' + draggableId}>
            <DragIndicatorIcon color='inherit' />
          </DragIcon>
        )}
        <Grid container spacing={2}>
          {[1, 2, 3, 4, 5].map((n) => (
            <Grid item xs={12} key={`tag${n}`}>
              <TextField
                fullWidth
                label={
                  logInUser?.attributes?.[`vt${n}`] ||
                  translate(`tag_${n}`)
                }
                select
                onChange={(e) =>
                  handleChange(`tag${n}`, e.target.value)
                }
                value={tagsState[`tag${n}`]}
              >
                <MenuItem value=''>None</MenuItem>
                {(alltags&&alltags[`tag${n}`] || [])?.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActionsStyled style={{ margin: 0, padding: 10 }}>
        <Button onClick={handleClose} variant='outlined' size='small'>
          {translate('sharedCancel')}
        </Button>
        {showSubmitbtn && (
          <Button
            onClick={handleSubmit}
            style={{ background: '#00c179', color: '#fff' }}
            variant='contained'
            color='success'
            size='small'
          >
            {translate('submit')}
          </Button>
        )}
        {headerActions}
      </DialogActionsStyled>
    </Dialog>
  )
}

const mapStateToProps = (state) => ({
  vehicles: state.vehicles,
  themecolors: state.themecolors
})

export default connect(mapStateToProps)(VehicleFilerModal)
